import React, { useEffect, useState } from "react";
import { Button, Spin, Table, Modal, Tag } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getOrderReducer } from "../../redux/Reducer/orderReducer";
import { getAdminOrderById, getAllUserOrders } from "../../redux/Actions";
// import { FormatNumber } from "../../Utils/cartmgt";
import MyPendingOrders from "../../Components/MyPendingOrders";
import noorderhistory from "../../asset/noorderhistory.png";

const OrderHistoryDashboard = (props) => {
  const [open, setOpen] = useState(false);
  const { authuserdetails } = props;
  const {
    allUserOrders,
    isloadingAllUserOrders,
    adminOrderById,
    isloadingAdminOrderById,
  } = useSelector(getOrderReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllUserOrders(authuserdetails?.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (pagination, filters, sorter, extra) => {
    dispatch(getAllUserOrders(authuserdetails?.id, pagination.current));
  };

  const handleShowUserOrderDetails = (orderid) => {
    dispatch(getAdminOrderById(orderid));
    setOpen(true);
  };

  // 👉 NEW: Helper function to calculate exact order total applying Promo logic
  const calculateCorrectOrderTotal = (record) => {
    // If no items array exists, fallback to the backend's root amount
    if (!record.items || record.items.length === 0) {
      return Number(record.amount) || 0;
    }

    let calculatedTotal = 0;

    record.items.forEach((item) => {
      const product = item.product;
      const qty = Number(item.qty) || 0;

      // Check if this specific item was a promo product
      if (
        product &&
        (product.is_promo_product === true || product.is_promo_product === 1)
      ) {
        const unit = Number(product.unit) || 1;
        const promoAmount = Number(product.promo_amount) || 0;

        if (unit > 0) {
          // Calculate based on bundle price
          calculatedTotal += (qty / unit) * promoAmount;
        }
      } else {
        // Standard Calculation
        calculatedTotal += (Number(product?.amount) || 0) * qty;
      }
    });

    return calculatedTotal;
  };

  // Helper to check if order has any promo items (for UI badge)
  const hasPromoInOrder = (record) => {
    return record.items?.some(
      (item) =>
        item.product?.is_promo_product === true ||
        item.product?.is_promo_product === 1,
    );
  };

  const columns = [
    {
      title: "ORDER ID",
      dataIndex: "id",
      render: (text) => <span className="orderHistory-text">{text}</span>,
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Transaction Reference",
      dataIndex: "reference",
      render: (text, record) => (
        <span className="orderHistory-text">
          {text}
          {hasPromoInOrder(record) && (
            <Tag color="gold" style={{ marginLeft: "8px", fontSize: "10px" }}>
              Promo
            </Tag>
          )}
        </span>
      ),
      sorter: (a, b) => a.reference.localeCompare(b.reference),
    },
    {
      title: "Date",
      dataIndex: "start_date",
      render: (text) => (
        <span className="orderHistory-text">
          {moment(text).format("MMM Do YYYY")} <br />{" "}
          <span className="orderHistory-time">
            At {moment(text).format("h:mm A")}
          </span>
        </span>
      ),
      sorter: (a, b) => a.start_date?.localeCompare(b?.start_date),
    },
    {
      title: "Total No Of Items",
      dataIndex: "items",
      render: (text, record) => (
        <span className="orderHistory-text">
          {text[0]?.product?.is_promo_product
            ? text[0]?.product?.unit * record.qty
            : record.qty}
        </span>
      ),
      // console.log("Items Array:", text[0].product),
      sorter: (a, b) => a.qty - b.qty,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (text) => <span className="orderHistory-text">{text}</span>,
      // render: (text, record) => {
      //   // 👉 Apply the calculation logic here
      //   const finalAmount = calculateCorrectOrderTotal(record);
      //   return (
      //     <span
      //       className="orderHistory-text"
      //       style={{
      //         fontWeight: hasPromoInOrder(record) ? "bold" : "normal",
      //         color: hasPromoInOrder(record) ? "#D4AF37" : "inherit",
      //       }}
      //     >
      //       {finalAmount === undefined || finalAmount === null
      //         ? "N/A"
      //         : FormatNumber(finalAmount)}
      //     </span>
      //   );
      // },
      sorter: (a, b) => {
        return calculateCorrectOrderTotal(a) - calculateCorrectOrderTotal(b);
      },
    },
    {
      title: "Status",
      dataIndex: "order_status",
      render: (text, record) => {
        let progressClass = "";
        switch (text.id) {
          case 1:
            progressClass = "orderHistory in-progress";
            break;
          case 2:
            progressClass = "orderHistory completed";
            break;
          case 6:
            progressClass = "orderHistory rejected";
            break;
          case 0:
            progressClass = "orderHistory rejected";
            break;
          default:
            progressClass = "orderHistory completed";
        }
        return (
          <span key={text.id} className={progressClass}>
            {text.name === "Initial" ? "Incoming" : text.name}
          </span>
        );
      },
      sorter: (a, b) =>
        a.order_status.name?.localeCompare(b?.order_status.name),
    },
    {
      title: "Actions",
      dataIndex: "id",
      render: (text, record) => (
        <>
          <Button
            type="text"
            onClick={() => handleShowUserOrderDetails(text)}
            className="orderHistory-view-details"
          >
            View Details
          </Button>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="row mt-5 mb-4">
        <Spin spinning={isloadingAllUserOrders} tip="Loading...">
          {allUserOrders && allUserOrders?.data?.length !== 0 ? (
            <Table
              columns={columns}
              dataSource={allUserOrders?.data}
              onChange={onChange}
              rowKey="id"
              scroll={{ x: 1000 }}
              pagination={{
                pageSize: allUserOrders?.meta?.per_page,
                showSizeChanger: true,
                pageSizeOptions: ["10", "15", "20", "30"],
                showQuickJumper: true,
                total: allUserOrders?.meta?.total,
                style: {
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                },
              }}
            />
          ) : (
            <p style={{ textAlign: "center" }}>
              <img
                src={noorderhistory}
                alt="no order history"
                height={"260px"}
                draggable={false}
              />
            </p>
          )}
        </Spin>
      </div>

      <Modal
        title="Order Details"
        style={{ top: 20 }}
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width={1000}
        footer={null} // Usually better to remove default OK/Cancel if MyPendingOrders has its own controls
      >
        <Spin spinning={isloadingAdminOrderById} tip="Loading...">
          <MyPendingOrders orderDetailsData={adminOrderById} />
        </Spin>
      </Modal>
    </>
  );
};

export default OrderHistoryDashboard;
